<template>
  <div class="home">
    <hero />
    <properties-section />
    <news />
    <about-section />
  </div>
</template>

<script>
import Hero from "@/components/home/Hero.vue";
import PropertiesSection from "@/components/home/PropertiesSection.vue";
import AboutSection from "@/components/home/AboutSection.vue";
import News from "@/components/home/News.vue";

export default {
  name: "Home",
  components: {
    Hero,
    PropertiesSection,
    AboutSection,
    News
  }
};
</script>

<style lang="scss" scoped>
.home {
  margin-top: 64px;

  @media (max-width: 768px) {
    margin-top: 0px;
  }
}
</style>
